// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.working-hours-widget {
  aspect-ratio: 1;
  max-height: 225px;
  min-height: 225px;
}
.working-hours-widget .working-hours-container {
  display: flex;
  flex-direction: column;
}
.working-hours-widget .time {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}
.working-hours-widget .time .startTime div, .working-hours-widget .time .endTime div {
  color: #888;
  font-size: 22px;
}
.working-hours-widget .time .startTime span, .working-hours-widget .time .endTime span {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  font-weight: 600;
}
.working-hours-widget .time .startTime span ion-icon, .working-hours-widget .time .endTime span ion-icon {
  color: #ed143d;
  font-size: 15px;
}
.working-hours-widget .days span {
  font-size: 12px;
  margin-inline: 3px;
  font-weight: 700;
}
.working-hours-widget .days span.active {
  color: #ed143d;
}

ion-spinner {
  margin: 0 auto;
  height: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/widgets/working-hours-widget/working-hours-widget.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;AACR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,QAAA;AADR;AAGY;EAEI,WAAA;EACA,eAAA;AAFhB;AAIY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AAFhB;AAGgB;EACI,cAAA;EACA,eAAA;AADpB;AAOQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;AALZ;AAMY;EAEI,cAAA;AALhB;;AAWA;EACI,cAAA;EACA,WAAA;AARJ","sourcesContent":[".working-hours-widget {\n    aspect-ratio: 1;\n    max-height :225px;\n    min-height: 225px;\n\n    .working-hours-container {\n        display: flex;\n        flex-direction: column;\n        // justify-content: space-between;\n    }\n    .time {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        // font-size: 15px;\n        gap: 5px;\n        .startTime , .endTime {\n            div {\n\n                color: #888;\n                font-size: 22px;\n            }\n            span {\n                display: flex;\n                align-items: center;\n                gap: 5px;\n                font-size: 13px;\n                font-weight: 600;\n                ion-icon {\n                    color: #ed143d;\n                    font-size: 15px;\n                }\n            }\n        }\n    }\n    .days {\n        span {\n            font-size: 12px;\n            margin-inline:3px;\n            font-weight: 700;\n            &.active {\n                \n                color: #ed143d;\n            }\n        }\n    }\n}\n\nion-spinner {\n    margin: 0 auto;\n    height: 8px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
